<!-- <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <button mat-icon-button disabled></button>
    {{node.name}}
  </mat-tree-node>
  <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
    <button mat-icon-button matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    {{node.name}}
  </mat-tree-node>
</mat-tree> -->

<div class="card" style="height: 89%">
  <div class="card-header card-header-squirrel">
    <!-- <h4>{{this.translate.data['ADDUSER'] | translate}}</h4>         -->
    <h4 *ngIf="selectUserPermissions">Benutzer anlegen - Projektgruppenrollen auswählen</h4>        
    <h4 *ngIf="selectTemplatesWithoutAdmin">Neues Projekt anlegen - Gruppenrollen Vorlagen auswählen</h4>        
    <h4 *ngIf="selectAllTemplates">Neuen Mandanten anlegen - Gruppenrollen Vorlagen auswählen</h4>        
  </div>
  <div class="card-body" *ngIf="allDataLoaded">

    <!-- ============= keine Vorlagen  -->
    <div class="dialog-content" *ngIf="isNoTemplate || isNoRoles">
    <a >Keine Vorlagen bzw. Projektgruppenrollen vorhanden!</a>
      <div class="row">
        <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 16px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                            (click)="cancel()" >zurück</button>
        </a>                                                
        <span style="flex: 1 1 auto"></span>
        <a *ngIf="selectUserPermissions">
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" 
            matTooltip="Benutzer mit ausgewählten Rollen anlegen"
            (click)="add()" 
            >Benutzer anlegen</button>
        </a>
        <a *ngIf="selectTemplatesWithoutAdmin">
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" 
            matTooltip="Projekt mit ausgewählten Vorlagen anlegen"
            (click)="add()" 
            >Projekt anlegen</button>
            <!-- [disabled]="isNoTemplate" -->
        </a>
        <a *ngIf="selectAllTemplates">
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" 
            matTooltip="Mandanten mit ausgewählten Vorlagen anlegen"
            (click)="add()" 
            >Mandant anlegen</button>
            <!-- [disabled]="isNoTemplate" -->
        </a>
      </div>    
    </div>

    <!-- ============= Vorlagen vorhanden -->    
    <div class="dialog-content" *ngIf="!isNoTemplate && !isNoRoles">
      <div style="max-height: 350px; overflow-y: auto;">


        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <!-- Knoten ohne Kinder -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <mat-checkbox 
              [checked]="node.checked" 
              (change)="toggleCheck(node)"
              class="black-checkbox">
              {{ node.name }}
            </mat-checkbox>
          </mat-tree-node>

          <!-- Knoten mit Kindern -->
          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
            <div class="node-header">
              <button mat-icon-button (click)="treeControl.toggle(node)">
                <mat-icon>
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>
              <mat-checkbox 
                [checked]="node.checked" 
                (change)="toggleCheck(node)"
                class="black-checkbox">
                {{ node.name }}
              </mat-checkbox>
            </div>
            <div *ngIf="treeControl.isExpanded(node)" style="margin-left: 48px;">
              <ng-container matTreeNodeOutlet></ng-container>
            </div>
          </mat-nested-tree-node>
        </mat-tree>
        <style>
          .black-checkbox .mat-checkbox-frame {
            border-color: #000 !important;
          }
          .black-checkbox.mat-checkbox-checked .mat-checkbox-background,
          .black-checkbox .mat-checkbox-background {
            background-color: #000 !important;
          }
          .black-checkbox .mat-checkbox-checkmark-path {
            stroke: #fff !important;
          }
        </style>


        <!-- <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodeToggle>
    <li>
      <div class="mat-tree-node">
      <button mat-icon-button matTreeNodeToggle>
        <mat-icon>
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
        <mat-checkbox
          [checked]="descendantsAllSelected(node)"
          [indeterminate]="descendantsPartiallySelected(node)"
          (change)="todoItemSelectionToggle(node)">
          {{node.name}}
        </mat-checkbox>
      </div>
    </li>
    <ul [class.tree-invisible]="!treeControl.isExpanded(node)">
      <ng-container matTreeNodeOutlet></ng-container>
    </ul>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node">
    <li class="mat-tree-node">
    <button mat-icon-button disabled></button>
      <mat-checkbox
        [checked]="checklistSelection.isSelected(node)"
        (change)="todoLeafItemSelectionToggle(node)">
        {{node.name}}
      </mat-checkbox>
    </li>
  </mat-tree-node>
</mat-tree> -->

<!-- <hr />

<button mat-raised-button (click)="console.log(getSelected())">
  Ausgewählte anzeigen
</button> -->

      </div>

      <div class="row">
        <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 16px" matTooltip="Zurück zur vorherigen Seite gehen"
                            (click)="cancel()" >Zurück</button>
        </a>                                                
        <span style="flex: 1 1 auto"></span>
        <a *ngIf="selectUserPermissions">
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" 
            matTooltip="Benutzer mit ausgewählten Rollen anlegen"
            (click)="add()" 
            >Benutzer anlegen</button>
        </a>
        <a *ngIf="selectTemplatesWithoutAdmin">
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" 
            matTooltip="Projekt mit ausgewählten Vorlagen anlegen"
            (click)="add()" 
            >Projekt anlegen</button>
            <!-- [disabled]="isNoTemplate" -->
        </a>
        <a *ngIf="selectAllTemplates">
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" 
            matTooltip="Mandanten mit ausgewählten Vorlagen anlegen"
            (click)="add()" 
            >Mandant anlegen</button>
            <!-- [disabled]="isNoTemplate" -->
        </a>
      </div>    
    </div>
  </div>
</div>
